import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles(({ palette, colors, breakpoints }: Theme) => createStyles({
  input: {
    '& .MuiInput-underline:after': {
      borderBottomColor: '#01B3C5',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#DCDEE5',
    },

    '&:hover .MuiInput-underline:before': {
      borderBottomColor: palette.input.borderBottomColor,
    },
  },
  focused: {},
  hovered: {},
  disabled: {
    color: palette.disabledInput.color,
  },
  error: {
    color: '#F8221A !important',
    '& .MuiInput-underline:before': {
      borderBottomColor: '#F8221A !important',
      borderBottom: '2px solid #F8221A !important',
    },
  },
  labelRoot: {
    color: '#515B6A !important',

  },
  labelRootError: {
    color: '#F8221A !important',
    '&.Mui-focused': {
      color: '#515B6A !important',
    },
  },
}), { name: 'StripeField' });

export default useStyles;
